import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SourceSystem } from '../../../models/customer.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { SourceSystemService } from '../../../services/source-system/source-system.service';

@Component({
  selector: 'app-source-system',
  templateUrl: './source-system.component.html',
  styleUrls: ['./source-system.component.css']
})
export class SourceSystemComponent implements OnInit {

  sourceSystemListTitles: DataTableField[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {}

  constructor(
    public sourceSystemService: SourceSystemService,
    private dataTableService: DataTableService,
    private translateService: TranslateService) {
      this.translateService.get([
      'sourceSystemList',
      'sourceSystemList.add_title',
      'sourceSystemList.edit_title'
    ]).subscribe((res) => {
        this.sourceSystemListTitles = [
          {id: 'id', label: '#'},
          {id: 'name', label: res.sourceSystemList.name},
          {id: 'description', label: res.sourceSystemList.description},
          {id: 'host_id', label: res.sourceSystemList.host_id}
        ];
        this.labels['add_title'] = res['sourceSystemList.add_title'];
        this.labels['edit_title'] = res['sourceSystemList.edit_title'];
      });
  }

  ngOnInit() {
    this.reloadList();
  }

  reloadList() {
    this.sourceSystemService.getList().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.sourceSystemService.sourceSystemEditing = data == null ? new SourceSystem() : data;
  }

  delete(record): void {
    this.sourceSystemService.delete(record).subscribe(() => {
      this.newDataAvailable = true;
      this.reloadList();
    });
  }

  sourceSystemAdded($event): void {
    this.sourceSystemService.post($event).subscribe(() => {
      this.dataTableService.get('dt_sourceSystem').showDetail = false;
      this.sourceSystemService.sourceSystemEditing = null;
      this.newDataAvailable = true;
      this.reloadList();
    })
  }

  sourceSystemUpdated($event): void {
    this.sourceSystemService.put($event, this.sourceSystemService.sourceSystemEditing.id).subscribe(() => {
      this.dataTableService.get('dt_sourceSystem').showDetail = false;
      this.sourceSystemService.sourceSystemEditing = null;
      this.newDataAvailable = true;
      this.reloadList();
    })
  }

  onDialogHide() {
    this.modalTitle = '';
    this.sourceSystemService.sourceSystemEditing = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/source-system/source-system.component.ts